<template>
  <div id="maps">

    <div class="map" ref="googleMap"></div>
  
  </div>
</template>

<script>

  export default {
    data () {
      return {
        sslcCenter: {
          lat: 42.931745,
          lng: -81.228082,
        },
        map: null,
        mapLatCenter: 42.938,
        markers: [],
        mapInstance: null
      }
    },
    methods: {
      init() {

        this.map = new google.maps.Map(this.$refs.googleMap, {
          zoom: 14,
          center: {
            lat: this.mapLatCenter,
            lng: this.sslcCenter.lng,
          },
          draggable: false
        });

        var contentString = '<div class="markerInfo"><div class="left">South London Community Centre<br><br>1119 Jalna Bvld<br>London, ON<br><br><a href="tel:519-661-5575">519-661-5575</a></div><div class="right"></div><div style="clear: both"></div><a style="text-decoration: none;" ref="https://www.google.com/maps/place/1119+Jalna+Blvd/@42.9309608,-81.2273537,18z/data=!4m2!3m1!1s0x882ef39487c14ff7:0xbb72010173267abd?hl=en" target="_blank"><div class="map-button">Open in Google Maps</div></a></div>';

        var marker = new google.maps.Marker({
          position: this.sslcCenter,
          map: this.map,
          title: 'South London Community Center'
        });
      
        marker.info = new google.maps.InfoWindow({
          content: contentString
        });
      
        marker.info.open(this.map, marker);

        marker.addListener('click', function() {
          marker.info.open(this.map, marker);
        });
       
      }
    },
    created () {
      setTimeout(() => {
        this.init();
      }, 1000);
    }
  }

</script>

<style lang="scss">

  #maps {
    height: 500px;
    position: relative;
  
    .map {
      width: 100%;
      height: 500px;
    }

    .markerInfo {
      padding: 10px 0px 10px 10px;
      line-height: 1.25em; 
      height: auto;
      color: #000;
      width: 280px;
    
      a {
        color: #000;
      }

      .map-button {
        border: 1px solid #DDD;
        background: #EFEFEF;
        padding: 5px;
        text-align: center;
        margin: 10px auto 0;
        width: 200px;
        text-decoration: none !important;
      }
    }


  }

</style>
